import createRightComponent from "../../../../helpers/common/CoreInputText/components/Right/fabric";
import { INPUT_TEXTAREA_DISPLAY_NAME } from "../../utils/core";

export const Component = createRightComponent(INPUT_TEXTAREA_DISPLAY_NAME);
export default Component;
